import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { prettyRenderFraction } from '../../../../../../../../javascript/bcom/pages/pip/pipApp/dimensions/Fractions';
import AspectRatio, { getAspectRatio } from '../../../AspectRatio';

// in percent
const PADDING = 20;
// in pixels
const LINE_WIDTH = 6;

const Text = styled.div`
background: #F4F4F4;
color: #43474D;
padding: 0 5px 0 5px;
line-height: 14px;
font-size: 12px;
z-index: 1;
white-space: nowrap;
`;
const Width = styled(Text)`
position: absolute;
left: 50%;
transform: translateX(-50%);
top: ${props => props.position}%;
`;
const Height = styled(Text)`
position: absolute;
top: 50%;
transform: translateY(-50%);
margin-right: -${() => LINE_WIDTH}px;
right: ${props => props.position}%;
`;
const Box = styled.div`
position: absolute;
height: ${props => props.dimensions.height * (100 - PADDING)}%;
width: ${props => props.dimensions.width * (100 - PADDING)}%;
border: ${() => LINE_WIDTH}px solid #43474D;
margin: auto;
top: 50%;
left: 50%;
transform: translate(-50%, -50%) rotate(180deg);
&:after {
  content: "";
  width: 100%;
  height: 8px;
  background: #43474D;
  padding-left: 12px;
  padding-right: 12px;
  margin-left: -12px;
  width: 100%;
  display: block;
  box-sizing: content-box;
}
`;

const WindowDimensionsVisualizer = ({
  width,
  height,
  className,
}) => {
  const dimensions = getAspectRatio(width, height);

  // the horizontal bar is going to be 50% of the height ratio away from the middle,
  // plus half the padding
  const widthPosition = ((50 - (dimensions.height * 50)) + (PADDING / 2));
  // the vertical bar is going to be 50% of the width ratio away from the middle,
  // plus half the padding
  const heightPosition = ((50 - (dimensions.width * 50)) + (PADDING / 2));

  return (
    <AspectRatio width={1} height={1} scale={0.5} className={className}>
      <Box dimensions={dimensions} />
      <Width position={widthPosition}>
        {prettyRenderFraction(width)}&quot;
      </Width>
      <Height position={heightPosition}>
        {prettyRenderFraction(height)}&quot;
      </Height>
    </AspectRatio>
  );
};
WindowDimensionsVisualizer.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  className: PropTypes.string,
};
WindowDimensionsVisualizer.defaultProps = {
  className: undefined,
};

export default WindowDimensionsVisualizer;
